import { IChatConversation, IChatMessage } from '../@types/chat';
import { axios } from '../utils/axios';

export type UserMentionType = 'message' | 'rowMessage';

export type IMention = Omit<IChatMessage, 'channel'> & {
  channel: IChatConversation;
} & {
  boardId: string;
  tableId: string;
  rowId: string;
};

export type MentionItem = {
  _id: string;
  owner: string;
  workspace: string;
  mentionRefId: string;
  readed: boolean;
  removed: boolean;
};

export type UserMention = {
  result: IMention;
  type: UserMentionType;
  readed: boolean;
  mention?: MentionItem;
};

export async function getMentions(): Promise<UserMention[]> {
  const { data } = await axios.get<UserMention[]>('/mention?allMentions=true');
  return data;
}

export async function readMention(mentionRefId: string): Promise<MentionItem> {
  const { data } = await axios.post<MentionItem>('/mention/read', {
    mentionRefId,
  });
  return data;
}

export async function removeMention(
  mentionRefId: string,
): Promise<MentionItem> {
  const { data } = await axios.put<MentionItem>('/mention/hide', {
    mentionRefId,
  });
  return data;
}

export * as MentionsRequest from './mentions';
